import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CurrentUserPreferencesEffects } from './store/current-user-preferences/current-user-preferences.effects';
import {
  CurrentUserPreferencesNamespace,
  CurrentUserPreferencesReducer,
} from './store/current-user-preferences/current-user-preferences.store';

@NgModule({
  imports: [
    StoreModule.forFeature(CurrentUserPreferencesNamespace, CurrentUserPreferencesReducer),
    EffectsModule.forFeature([CurrentUserPreferencesEffects]),
  ],
})
export class CurrentUserPreferencesDataModule {}
